import { DefaultService } from '@/services/DefaultService';
import * as Util from '@/functions/Util';

export default class VendasClienteService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    /* ABA MIX */
    loadMix(idCliente, page, limit, column, order) {
        return this._http.get(`${this._env}/cliente/${idCliente}/mix.json?page=${page}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    /* ABA ANEXOS */
    loadAnexosVendas(idCliente, idClienteErp, page, limit, column, order, cnpjcpf = "") {
        return this._http.get(`${this._env}/ven/cliente/${idCliente}/attachment.json?page=${page}&idclienteerp=${idClienteErp}&limit=${limit}&order=${order}&column=${column}&cnpjcpf=${cnpjcpf}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadAnexosAgro(idCliente, idClienteErp, page, limit, column, order, cnpjcpf = "") {
        return this._http.get(`${this._env}/agro/cliente/${idCliente}/attachment.json?page=${page}&idclienteerp=${idClienteErp}&limit=${limit}&order=${order}&column=${column}&cnpjcpf=${cnpjcpf}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAnexo(file, attachment) {
        attachment = Util.mapToupload(attachment);

        // Cria o formData para enviar o arquivo
        var data = new FormData();
        data.append("file", file);
        // Adiciona o objeto com os dados auxiliares do anexo.
        data.append("anexocliente", new Blob([JSON.stringify( attachment )],
        {
            type: "application/json"
        }));
        data.append("anexocliente", attachment);

        // Altera o Header para adicionar os headers necessários do multipart-data
        let requestHeader = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: data
        }

        // Remove o content-type do header para forçar o navegador a inseri-los novamente, gerando corretamente o content-type necessário.
        delete requestHeader.headers["Content-Type"];

        return this._http.post(`${this._env}/cliente/attachment`, data, requestHeader).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    deleteAnexoVendas(idanexocliente) {
        return this._http.delete(`${this._env}/ven/cliente/attachment/${idanexocliente}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    deleteAnexoAgro(idanexocliente) {
        return this._http.delete(`${this._env}/agro/cliente/attachment/${idanexocliente}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateLocation(cliente) {
        return this._http.post(`${this._env}/cliente/location`, cliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(page = 0, limit = 50, filter) {
        return this._http.post(`${this._env}/cliente/all.json?page=${page}&limit=${limit}`, filter, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAll(limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/cliente/list.json?limit=${limit}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(`${this._env}/getcombo/cliente.json?situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    listByEmpresa(limit = 0, idempresa = 0, ...params) {
        return this._http.get(`${this._env}/cliente/listbyempresa.json?limit=${limit}&idempresa=${idempresa}&param=${params}`, this._headers).then(res => {
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    /* DESCONTO POR QUANTIDADE */

    loadDescontos(idcliente) {
        return this._http.get(`${this._env}/cliente/${idcliente}/produtoqtdepreco`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadProdutosDisponiveis(idcliente, page, limit, q) {
        return this._http.get(`${this._env}/cliente/${idcliente}/available-produtoqtdepreco?page=${page}&limit=${limit}&param=${q}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveDesconto(desconto) {
        return this._http.post(`${this._env}/product/produtoqtdepreco`, desconto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delDesconto(idprodutoqtdepreco) {
        return this._http.delete(`${this._env}/product/produtoqtdepreco/${idprodutoqtdepreco}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    /* ABA CHECKIN/OUT */
    loadChecks(idCliente, page, limit, column, order) {
        return this._http.get(`${this._env}/cliente/${idCliente}/checks.json?page=${page}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    getUltimosPedidos(idcliente, limit = 20, query) {
        return this._http.get(`${this._env}/cliente/${idcliente}/lastorders.json?limit=${limit}&param=${query}`, this._headers)
            .then(res => res.body, this.handleError);
    }

    /* ABA PROPRIEDADES */
    loadPropriedadesVendas(idCliente, page, limit, column, order, situacao, ...params) {
        return this._http.get(`${this._env}/ven/cliente/${idCliente}/properties.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadPropriedadesAgro(idCliente, page, limit, column, order, situacao, ...params) {
        return this._http.get(`${this._env}/agro/cliente/${idCliente}/properties.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadClienteReduced(idCliente) {
        return this._http.get(`${this._env}/cliente/${idCliente}/reduced.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllByIdUuid(uuid) {
        return this._http.get(`${this._env}/cliente/findAllByUuidAtendimento/${uuid}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}